import {ThemeProvider, Toast} from '@fattureincloud/fic-design-system'
import React, {FC, useEffect} from 'react'
import {Route, Routes} from 'react-router-dom'
import {Navigate, useNavigate} from 'react-router-dom'

import {theme} from '../../config/theme'
import {locale} from '../../locales/locale'
import Customerly from '../../plugins/customerly/Customerly'
import {
  activateAdminMode,
  disableAdminMode,
} from '../../redux/features/adminMode/adminModeSlice'
import {isRealm, setRealm} from '../../redux/features/realm/realmSlice'
import {useAppDispatch, useAppSelector} from '../../redux/hooks'
import useLocale from '../../redux/useLocale'
import usePollingChatConfig from '../../redux/usePollingChatConfig'
import {MainPageDefault} from './customComponents'
import Section from './Section'
import {setLocale} from "../../redux/features/locale/localeSlice";

const ExternalApp: FC = () => {
  usePollingChatConfig()
  useLocale()
  const adminMode = useAppSelector((state) => state.adminMode.value)
  const dispatch = useAppDispatch()
  const language = useAppSelector((state) => state.locale.value)


  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  const setCurrentRealm = (origin: string) => {
    document.title = locale('Guide')
    if (origin.endsWith('reseller.madbit.it')) {
      document.title + ' ' + locale('Resellers')
      return dispatch(setRealm({ value: 'resellers' }))
    }
    if (origin.endsWith('.dipendentincloud.it')) {
      document.title + ' ' + locale('Dipendenti in Cloud')
      return dispatch(setRealm({ value: 'dic' }))
    }
    if (origin.endsWith('.gestiondeempleados.com')) {
      document.title + ' ' + locale('Dipendenti in Cloud')
      dispatch(setLocale({ value: 'es' }))
      return dispatch(setRealm({ value: 'dic-es' }))
    }
    document.title + ' ' + locale('Fatture in Cloud')
    return dispatch(setRealm({ value: 'fic' }))
  }

  const favoriteRealm = getCookie('favoriteRealm')
  useEffect(() => {

    const isItRealm = isRealm(favoriteRealm)
    dispatch(setRealm({value: isItRealm ? favoriteRealm : 'fic'}))
  }, [])

  useEffect(() => {
    const isAdminMode = getCookie('adminMode')
    if (isAdminMode === '1') {
      const favoriteRealm = getCookie('favoriteRealm')
      const isItRealm = isRealm(favoriteRealm)
      if (!adminMode) {
        dispatch(setRealm({value: isItRealm ? favoriteRealm : 'fic'}))
      }
      dispatch(activateAdminMode(isItRealm ? favoriteRealm : 'fic'))
    } else {
      setCurrentRealm(window.location.origin)
      disableAdminMode()
    }
  }, [language])

  const navigate = useNavigate()

  const handleChangeView = (permalink: string, page: string) => {
    const path = page && permalink ? page + '/' + permalink : ''
    navigate('/help/' + path)
  }

  const MissingRoute = () => {
    return <Navigate to={'/help'}/>
  }

  return (
      <ThemeProvider theme={theme}>
        <Toast.Container position={'bottom-right'}/>
        <Customerly/>
        <Routes>
          <Route
              path={'/help'}
              element={
                <MainPageDefault
                    changeView={handleChangeView}
                    className={'mainpageDefault'}
                    embedded={false}
                />
              }
          />
          <Route
              path={'/help/:type'}
              element={<Section handleChangeView={handleChangeView}/>}
          />
          <Route
              path={'/help/:type/:id'}
              element={<Section handleChangeView={handleChangeView}/>}
          />
          <Route path='*' element={<MissingRoute/>}/>
        </Routes>
      </ThemeProvider>
  )
}

export default ExternalApp
